type GuestProfileUser = {
  phone?: string | null;
  whatsappNumber?: string | null;
  whatsapp?: string | null;
} | null;

/**
 * Guest details form on Pay Now should only show when phone or WhatsApp is missing.
 * Pass this boolean into booking navigation state to avoid UI flash.
 */
export function shouldShowGuestProfileForm(user?: GuestProfileUser): boolean {
  if (!user) return true;
  const phone = String(user.phone || "").trim();
  const whatsapp = String(user.whatsappNumber || user.whatsapp || "").trim();
  return !(phone && whatsapp);
}
